import { FLIGHT_STATUS } from "@/enum";

export default [
    {
      path: "/flights",
      meta: {
        requiresAuth: false,
        permission: null,
        title: "Vuelos",
        layout: "admin",
        module: "flights",
        icon: "mdi-airplane",
        notBreadCrumb: true,
      },
      component: () =>
        import(/* webpackChunkName: "fliesLayout" */ "@/views/flights/FlightsLayout.vue"),
      children: [
        {
          path: "",
          name: "flights",
          meta: {
            requiresAuth: true,
            permission: null,
            layout: "admin",
            title: "Listados",
            adminLayoutNav: true,
            icon: "mdi-format-list-bulleted",
            notBreadCrumb: true,
            module: "flights",
            requestUrl: '/flight_requests',
            statusOptions: [
              {
                text: "Pendiente",
                value: FLIGHT_STATUS.PENDING
            },
            {
                text: "Programado",
                value: FLIGHT_STATUS.PROGRAMED
            },
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "flyRequest" */ "@/views/flights/FlightRequests.vue"
            ),
        },
        {
          path: "historial",
          name: "flights-historial",
          meta: {
            requiresAuth: true,
            permission: null,
            layout: "admin",
            module: "flights",
            title: "Historial",
            adminLayoutNav: true,
            icon: "mdi-clipboard-text-clock-outline",
            notBreadCrumb: true,
            requestUrl: '/flight_request_historial',
            statusOptions: [
              {
                text: "Cancelado",
                value: FLIGHT_STATUS.CANCELED
              },
              {
                text: "Completado",
                value: FLIGHT_STATUS.COMPLETED
              }
            ]
          },
          component: () =>
            import(
              /* webpackChunkName: "flyRequest" */ "@/views/flights/FlightRequests.vue"
            ),
        },
      ],
    },
  ];
  